import React, { useEffect, createElement } from 'react';
export function CookieBanner() {
  useEffect(() => {
    // Cookie banner functionality
    const cookieBanner = document.getElementById('cookie-banner');
    const preferencesModal = document.getElementById('preferences-modal');
    // Buttons im Banner
    const acceptAllBtn = document.getElementById('accept-all-cookies');
    const declineAllBtn = document.getElementById('decline-all-cookies');
    const manageBtn = document.getElementById('manage-preferences');
    // Elemente im Einstellungs-Fenster
    const closeModalBtn = document.getElementById('close-modal');
    const savePreferencesBtn = document.getElementById('save-preferences');
    const personalizationCheckbox = document.getElementById('personalization-cookies');
    const marketingCheckbox = document.getElementById('marketing-cookies');
    const analyticsCheckbox = document.getElementById('analytics-cookies');
    // --- Ladefunktionen für Skripte ---
    function loadPersonalizationScripts() {
      console.log('Personalisierungs-Skripte geladen.');
      // Fügen Sie hier Skripte für Personalisierung ein (z.B. A/B-Testing Tools)
    }
    function loadMarketingScripts() {
      console.log('Marketing-Skripte geladen.');
      // HIER FACEBOOK PIXEL CODE EINFÜGEN
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '711052744955079');
      fbq('track', 'PageView');
    }
    function loadAnalyticsScripts() {
      console.log('Analyse-Skripte geladen.');
      // Fügen Sie hier Skripte für Analysen ein (z.B. Google Analytics, Matomo)
    }
    function executeConsentedScripts() {
      const consentCookie = getCookie('cookie_consent');
      if (!consentCookie) return;
      const consent = JSON.parse(consentCookie);
      if (consent.personalization) loadPersonalizationScripts();
      if (consent.marketing) loadMarketingScripts();
      if (consent.analytics) loadAnalyticsScripts();
    }
    // --- Cookie Hilfsfunktionen ---
    function setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }
    function getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    // --- UI Funktionen ---
    function showBanner(shouldShow) {
      if (cookieBanner) {
        if (shouldShow) {
          cookieBanner.style.display = 'block';
        } else {
          cookieBanner.style.display = 'none';
        }
      }
    }
    function showPreferences(shouldShow) {
      if (preferencesModal) {
        if (shouldShow) {
          const consentCookie = getCookie('cookie_consent');
          if (consentCookie && personalizationCheckbox && marketingCheckbox && analyticsCheckbox) {
            const consent = JSON.parse(consentCookie);
            personalizationCheckbox.checked = consent.personalization;
            marketingCheckbox.checked = consent.marketing;
            analyticsCheckbox.checked = consent.analytics;
          }
          preferencesModal.style.display = 'flex';
        } else {
          preferencesModal.style.display = 'none';
        }
      }
    }
    // --- Event Listeners ---
    if (acceptAllBtn) {
      acceptAllBtn.addEventListener('click', function () {
        const consent = {
          required: true,
          personalization: true,
          marketing: true,
          analytics: true
        };
        setCookie('cookie_consent', JSON.stringify(consent), 365);
        showBanner(false);
        executeConsentedScripts();
      });
    }
    if (declineAllBtn) {
      declineAllBtn.addEventListener('click', function () {
        const consent = {
          required: true,
          personalization: false,
          marketing: false,
          analytics: false
        };
        setCookie('cookie_consent', JSON.stringify(consent), 365);
        showBanner(false);
      });
    }
    if (manageBtn) {
      manageBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showPreferences(true);
      });
    }
    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', () => showPreferences(false));
    }
    if (savePreferencesBtn) {
      savePreferencesBtn.addEventListener('click', function () {
        if (personalizationCheckbox && marketingCheckbox && analyticsCheckbox) {
          const consent = {
            required: true,
            personalization: personalizationCheckbox.checked,
            marketing: marketingCheckbox.checked,
            analytics: analyticsCheckbox.checked
          };
          setCookie('cookie_consent', JSON.stringify(consent), 365);
          showPreferences(false);
          showBanner(false);
          // Neu laden, um Skripte korrekt anzuwenden, oder Skripte dynamisch ausführen
          window.location.reload();
        }
      });
    }
    // --- Initialisierungslogik ---
    if (!getCookie('cookie_consent')) {
      showBanner(true);
    } else {
      showBanner(false);
      executeConsentedScripts();
    }
    // Cleanup function to remove event listeners
    return () => {
      if (acceptAllBtn) acceptAllBtn.removeEventListener('click', () => {});
      if (declineAllBtn) declineAllBtn.removeEventListener('click', () => {});
      if (manageBtn) manageBtn.removeEventListener('click', () => {});
      if (closeModalBtn) closeModalBtn.removeEventListener('click', () => {});
      if (savePreferencesBtn) savePreferencesBtn.removeEventListener('click', () => {});
    };
  }, []);
  return <>
      <div id="cookie-banner" className="cookie-banner" style={{
      display: 'none'
    }} data-id="element-85">
        <div className="cookie-banner-content" data-id="element-86">
          <p data-id="element-87">
            Wir verwenden Cookies, um unsere Dienste zu verbessern. Wählen Sie
            Ihre Präferenzen oder akzeptieren Sie alle. Weitere Informationen in
            unserer{' '}
            <a href="https://tiansole.de/pages/datenschutz" data-id="element-88">
              Datenschutzerklärung
            </a>
            .
          </p>
          <div className="cookie-options" data-id="element-89">
            <button id="accept-all-cookies" className="cookie-btn accept" data-id="element-90">
              Alle akzeptieren
            </button>
            <button id="decline-all-cookies" className="cookie-btn decline" data-id="element-91">
              Nur erforderliche
            </button>
            <a href="#" id="manage-preferences" className="cookie-link" data-id="element-92">
              Einstellungen anpassen
            </a>
          </div>
        </div>
      </div>
      <div id="preferences-modal" className="modal-overlay" style={{
      display: 'none'
    }} data-id="element-93">
        <div className="modal-content" data-id="element-94">
          <div className="modal-header" data-id="element-95">
            <h3 data-id="element-96">Cookie-Einstellungen</h3>
            <button id="close-modal" className="close-modal-btn" data-id="element-97">
              &times;
            </button>
          </div>
          <h4 data-id="element-98">Sie kontrollieren Ihre Daten</h4>
          <p data-id="element-99">
            Lernen Sie mehr über die von uns verwendeten Cookies und wählen Sie
            aus, welche Sie zulassen möchten.
          </p>
          <div className="preference-category" data-id="element-100">
            <div className="preference-header" data-id="element-101">
              <label htmlFor="required-cookies" data-id="element-102">Erforderlich</label>
              <input type="checkbox" id="required-cookies" checked disabled data-id="element-103" />
              <span className="toggle-switch-disabled" data-id="element-104"></span>
            </div>
            <p className="preference-description" data-id="element-105">
              Diese Cookies sind für die Funktion der Website erforderlich und
              können nicht deaktiviert werden, z.B. für den Warenkorb.
            </p>
          </div>
          <div className="preference-category" data-id="element-106">
            <div className="preference-header" data-id="element-107">
              <label htmlFor="personalization-cookies" data-id="element-108">Personalisierung</label>
              <input type="checkbox" id="personalization-cookies" data-id="element-109" />
              <label htmlFor="personalization-cookies" className="toggle-switch" data-id="element-110"></label>
            </div>
            <p className="preference-description" data-id="element-111">
              Diese Cookies speichern Informationen über Ihre Aktionen, um Ihren
              nächsten Besuch auf der Website zu personalisieren.
            </p>
          </div>
          <div className="preference-category" data-id="element-112">
            <div className="preference-header" data-id="element-113">
              <label htmlFor="marketing-cookies" data-id="element-114">Marketing</label>
              <input type="checkbox" id="marketing-cookies" data-id="element-115" />
              <label htmlFor="marketing-cookies" className="toggle-switch" data-id="element-116"></label>
            </div>
            <p className="preference-description" data-id="element-117">
              Diese Cookies werden verwendet, um die Marketingkommunikation zu
              optimieren und Ihnen auf anderen Websites relevante Anzeigen zu
              zeigen.
            </p>
          </div>
          <div className="preference-category" data-id="element-118">
            <div className="preference-header" data-id="element-119">
              <label htmlFor="analytics-cookies" data-id="element-120">Analyse</label>
              <input type="checkbox" id="analytics-cookies" data-id="element-121" />
              <label htmlFor="analytics-cookies" className="toggle-switch" data-id="element-122"></label>
            </div>
            <p className="preference-description" data-id="element-123">
              Diese Cookies helfen uns zu verstehen, wie Sie mit der Website
              interagieren. Wir nutzen diese Daten, um Verbesserungspotenziale
              zu identifizieren.
            </p>
          </div>
          <button id="save-preferences" className="cookie-btn accept" data-id="element-124">
            Meine Auswahl speichern
          </button>
        </div>
      </div>
      <style jsx data-id="element-125">{`
        .cookie-banner {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background-color: #f1f1f1;
          padding: 20px;
          box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          font-family: sans-serif;
        }
        .cookie-banner-content {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 20px;
        }
        .cookie-banner p {
          margin: 0;
          font-size: 14px;
        }
        .cookie-options {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
        }
        .cookie-btn {
          border: 1px solid #333;
          background-color: #fff;
          color: #333;
          padding: 10px 20px;
          cursor: pointer;
          border-radius: 5px;
          font-size: 14px;
          white-space: nowrap;
        }
        .cookie-btn.accept {
          background-color: #333;
          color: #fff;
        }
        .cookie-link {
          font-size: 14px;
          color: #333;
          text-decoration: underline;
          white-space: nowrap;
        }
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1001;
        }
        .modal-content {
          background-color: #fff;
          padding: 30px;
          border-radius: 8px;
          max-width: 550px;
          width: 90%;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        }
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }
        .modal-header h3 {
          margin: 0;
        }
        .close-modal-btn {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
        }
        .preference-category {
          margin-bottom: 20px;
          padding-top: 15px;
          border-top: 1px solid #eee;
        }
        .preference-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .preference-header label {
          font-weight: bold;
        }
        .preference-description {
          font-size: 13px;
          color: #666;
          margin-top: 5px;
        }
        input[type='checkbox'] {
          display: none;
        }
        .toggle-switch {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 24px;
          background-color: #ccc;
          border-radius: 24px;
          cursor: pointer;
          transition: background-color 0.3s;
        }
        .toggle-switch::after {
          content: '';
          position: absolute;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: white;
          top: 2px;
          left: 2px;
          transition: transform 0.3s;
        }
        input:checked + .toggle-switch {
          background-color: #333;
        }
        input:checked + .toggle-switch::after {
          transform: translateX(16px);
        }
        .toggle-switch-disabled {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 24px;
          background-color: #333;
          border-radius: 24px;
          opacity: 0.5;
        }
        .toggle-switch-disabled::after {
          content: '';
          position: absolute;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: white;
          top: 2px;
          left: 18px;
        }
        @media (max-width: 768px) {
          .cookie-banner-content {
            flex-direction: column;
            align-items: flex-start;
          }
          .cookie-options {
            margin-top: 15px;
            flex-wrap: wrap;
          }
        }
      `}</style>
      <noscript data-id="element-126">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=711052744955079&ev=PageView&noscript=1" alt="" data-id="element-127" />
      </noscript>
    </>;
}